export default __webpack_public_path__ + "static/media/firefightersHome.c71b3686.jpeg";